export default class ProductPartsService {
  constructor(Api) {
    "ngInject";
    this.api = Api;
  }

  loadAllShapes() {
    return this.api.call({
      method: 'get',
      url: '/shapes'
    })
  }

  loadAllFixmethods() {
    return this.api.call({
      method: 'get',
      url: '/fixmethods'
    })
  }

  loadAllColors() {
    return this.api.call({
      method: 'get',
      url: '/colors'
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-parts/parts.service.js
 **/